<template>
  <router-view></router-view>
</template>

<style lang="scss">
@import './assets/styles/base.scss';

.el-form-item {
  margin-bottom: 12px;
}

.el-input-number__decrease, .el-input-number__increase {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #34b3f9;
}

.el-input-number {
  width: 80px
}

.el-input-number .el-input__wrapper {
  padding-left: 15px;
  padding-right: 15px
}

.el-input-number .el-input__inner {
  height: 24px;
}

.el-input-number .el-icon {
  color: #fff;
  font-size: 11px;
  width: 12px;
  height: 12px;
}

.total .el-input.is-disabled .el-input__inner {
  color: #EB5757;
}

.el-dialog {
  padding: 0 !important;
  border-radius: 20px !important;
  overflow: hidden;

  .el-dialog__header {
    padding: 0 !important;
    background: #F9F9F9;
    line-height: 58px;
    font-size: 16px;
    color: #000000;
    text-align: center;
    margin: 0;
  }

  .el-dialog__body {
    padding: 25px;
  }

  .el-dialog__footer {
    padding: 0 30px 25px 0;
  }
}

.el-button.is-round {
  padding: 8px 25px 8px 25px !important;
  height: auto !important;
}

.info-body {
  .el-tabs__nav-scroll {
    padding-left: 20px;
  }
}

.one-group {
  .el-radio {
    display: block;
    width: 100%;
  }
}

.dialog-tips {
  .el-table__inner-wrapper {
    font-size: 12px !important;
  }

  .el-table--border .el-table__cell {
    padding: 0 !important;
  }
}
</style>
